import { render } from "./UploadRcu.vue?vue&type=template&id=50f65b0a&scoped=true"
import script from "./UploadRcu.vue?vue&type=script&lang=js"
export * from "./UploadRcu.vue?vue&type=script&lang=js"

import "./UploadRcu.vue?vue&type=style&index=0&id=50f65b0a&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f65b0a"]])

export default __exports__